<script>
  import SiblingDetails from "../components/application/siblingdetails.svelte";
	import * as ExtractMsg from "../components/Utils/UserMsgFromInvalidResponse.js";
  import { GetChild } from "../components/application/service.js";
  import Modal from "../components/HTMLElements/Modal.svelte";
  import wrappedFetch from "../wrappedFetch.js";
  import { onMount, createEventDispatcher } from "svelte";
  export let childId;
  let sibling ;
  let DefaultSibling;
  let siblingDetailsInstance;
  let error;
  let showApplicationResubmitModal = false;
  let applications=[];
  let lateApplications=[];
  const dispatch = new createEventDispatcher();

  const saveAndNavigate = async () => {
    
		async function callSaveAction()
		{
          let data;
          var resp = await wrappedFetch("/child/SaveSibling", {
            method: "post",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(sibling)
          })
          .then(response => response.json())
          .then(response => {
              if (response.success) 
	            {
                data = response.data;
              }
              else
	            {
                error = "Problem saving child details.";
                //if (IS_DEV) console.log("Error saving child details.");
                let message = "Problem saving the child details (no details).";
                if (typeof(response.message) !== 'undefined')
                {
                  error = response.message;
                  message = response.message;
                  let extract = ExtractMsg.ExtractUserMsgFromInvalidResponse(message);
                  if (extract !== "" && extract.length > 0)
                  {
                    error = extract;
                    
                    extract = "";
                    extract = ExtractMsg.ExtractConsoleMsgFromInvalidResponse(message);
                    if (extract !== "" && extract.length > 0)
                    {
                      message = extract;
                    }
                  }
                }
              }

          });
          return data;
    }
 
    if (await siblingDetailsInstance.validateAndSave()) 
    {
         if(JSON.stringify(DefaultSibling) === JSON.stringify(sibling))
          {
              dispatch("pageChange", "/user/home");      
            return;
          }

          var resp = await callSaveAction()
            .then (resp => {
                //response = response.data;
                if (typeof(resp) !== "undefined" && resp.success) 
                {
                    //applications=resp.applications || [];
                    //lateApplications = resp.lateApplications || [];
              
                    //showApplicationResubmitModal = (applications.length > 0 || lateApplications.length > 0);      
                        
                    if(!showApplicationResubmitModal)
                    {
                          dispatch("pageChange", "/user/home");   
                    }         
                }
              } );
    }
  };

  onMount(async () => {
    sibling = await GetChild(childId);
     DefaultSibling = JSON.parse(JSON.stringify(sibling));
  });
</script>

{#if sibling}
  <section class="section">
    <div class="container">
      <div class="columns is-centered is-desktop">
        <div class="column is-10-desktop" />
      </div>
      <div class="columns is-centered is-desktop">
        <div class="column is-7-tablet is-8-desktop is-8-widescreen">
          <div>
            <a href="/user/home">
              <span class="fas fa-arrow-left" />
              Back
            </a>
          </div>
            
  <h1 class="title is-3">Sibling details</h1>
          <SiblingDetails
            schoolId={sibling.currentSchoolId}
            bind:sibling
            bind:this={siblingDetailsInstance}
            {error} />
          <div style="margin-top:10px">
            <button class="button is-primary" on:click={saveAndNavigate}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
{/if}

<Modal bind:showModal={showApplicationResubmitModal}>
  {#if applications.length > 0}
    <div style="padding: 1em;">
      <h1 class="title is-4"> You must resubmit following application(s) </h1>
      {#each applications as a}
        <p><span style="padding-left:1em;">{a.reference}</span></p>
        <br/>
      {/each}
    </div>
  {/if}
  {#if applications.length == 1 }
    <div style="padding: 1em;">
      <h1 class="title is-4"> You must resubmit this application. </h1>
      <p> Please select "Continue" to carry on making changes to your application or "Resubmit" to submit your changes.</p>
    </div> 
  {:else if  applications.length > 1}
    <div style="padding: 1em;">
      <h1 class="title is-4"> You must resubmit this application. </h1>
      <p> Please select "Continue" to carry on making changes to your application or resubmit appication from your home page. </p> 
    </div>
  {/if}

  {#if lateApplications.length > 0}
  <hr/>
  <strong>Local Authorities notified</strong><br/>
  <p>The relevant Local Authorities have been notified about the changes you have made. Please contact the <a href='https://www.eadmissions.org.uk/contact/' target='_blank' style='text-decoration:underline'>Authority</a> if the child has moved home address.</p><br/>
  {#each applications as la}
 <p><span>{la.reference}</span></p><br/>
  {/each}
  {/if}

  <footer class="modal-card-foot buttons is-right" slot="footer">
    <button
      class="button continue is-primary"
      on:click={() => {
        showApplicationResubmitModal = false;
        dispatch('pageChange','/user/home');
      }}>
      Continue
    </button>
{#if applications.length > 0}
    <button  
      class="button continue is-purple" 
      on:click={()=>{    
        showApplicationResubmitModal = false;
        if(applications.length == 1)
          dispatch('pageChange', `/application/submit/${applications[0].childId}/${applications[0].id}`);
        else      
        dispatch('pageChange', '/user/home'); 
      }  
      }>
      Resubmit
    </button>
    {/if}

  </footer>
</Modal>

